import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { ZustandStorageKeys } from '~/constants/zustandStorageKeys';

export type WorkspaceAgentMentionPickerState = {
  /** Per workspace: a member of two workspaces mentions from a different kit in each. */
  selectedBrandKitIdByWorkspaceId: Record<string, string>;
  selectBrandKit: (workspaceId: string, brandKitId: string) => void;
};

/**
 * Persisted, unlike the source chip: which kit a user mentions images from is a standing preference,
 * while the tab the picker opens on only lives as long as the composer.
 */
export const useWorkspaceAgentMentionPickerStore = create<WorkspaceAgentMentionPickerState>()(
  persist(
    (set) => ({
      selectBrandKit: (workspaceId, brandKitId) =>
        set((state) => ({
          selectedBrandKitIdByWorkspaceId: {
            ...state.selectedBrandKitIdByWorkspaceId,
            [workspaceId]: brandKitId,
          },
        })),
      selectedBrandKitIdByWorkspaceId: {},
    }),
    {
      name: ZustandStorageKeys.WorkspaceAgentMentionPicker,
      partialize: ({ selectedBrandKitIdByWorkspaceId }) => ({ selectedBrandKitIdByWorkspaceId }),
    },
  ),
);
